import { FCC } from "@/types/common";
import { Typography, Stack, styled } from "@mui/material";
import { EMPTY_STR } from "@/constants/string";
import Divider from "@mui/material/Divider";
import { black } from "@/theme/colors";

type TSettingInfoItem = {
  label?: string;
  value?: string | null | undefined;
  direction?: "row" | "column";
  isShowDivider?: boolean;
};
export const SettingInfoItem: FCC<TSettingInfoItem> = ({ label, value, direction, isShowDivider = true }) => {
  return (
    <>
      <SettingInfoItemWrapper direction={direction} gap={1}>
        {label && (
          <Typography variant="cap12" color={black[70]}>
            {label}
          </Typography>
        )}
        <Stack direction="row" justifyContent="space-between">
          <ValueTypography variant="body14Semi" color={black[30]}>
            {value ? value : EMPTY_STR.TEXT}
          </ValueTypography>
        </Stack>
        {isShowDivider && <DividerWrapper />}
      </SettingInfoItemWrapper>
    </>
  );
};

const SettingInfoItemWrapper = styled(Stack)<{ direction?: string }>`
  ${({ direction }) => (direction === "row" ? `align-items: center;` : ``)}
`;

const ValueTypography = styled(Typography)`
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  max-width: 100%;
`;

const DividerWrapper = styled(Divider)`
  margin: 8px 0;
  width: 100%;
`;
